// extracted by mini-css-extract-plugin
module.exports = {"accounts__connect-link":"Accounts_accounts__connect-link__YmCWZ","accounts__connect-link_as-button":"Accounts_accounts__connect-link_as-button__2NZ_J"};